import { z } from 'zod';
export const getBadgeDetailsRequestSchema = z.object({
    id: z.string().uuid(),
});
export const getBadgeDetailsResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    description: z.string().optional(),
    expirationIntervalMonths: z.number(),
    organizationIds: z.string().uuid().array(),
    validAccountBadgesCount: z.number(),
    invalidAccountBadgesCount: z.number(),
    expiredAccountBadgesCount: z.number(),
    reissueNeededAccountBadgesCount: z.number(),
    revokedAccountBadgesCount: z.number(),
    accountBadges: z
        .object({
        accountId: z.string().uuid(),
    })
        .array(),
});
export const getBadgeDetailsFunctionDef = {
    name: 'getBadgeDetails',
    requestSchema: getBadgeDetailsRequestSchema,
    responseSchema: getBadgeDetailsResponseSchema,
};
